export default __webpack_public_path__ + "static/media/sunsculpted14.a54740e5.jpg";